import { Box, Button, ButtonProps, CircularProgress, CircularProgressProps, Theme, SxProps } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Wrapper } from './Wrapper';

const DEFAULT_SPINNER_SIZE = 24;

export interface ProgressButtonProps extends ButtonProps {
  loading?: boolean;
  spinnerProps?: CircularProgressProps;
  wrapperSxProps?: SxProps<Theme>;
  buttonSxProps?: SxProps<Theme>;
}

export const ProgressButton: FunctionComponent<PropsWithChildren<ProgressButtonProps>> = (props) => {
  const { loading, disabled, spinnerProps, wrapperSxProps = {}, buttonSxProps = {}, ...rest } = props;

  const spinnerSize = spinnerProps?.size ? Number(spinnerProps.size) : DEFAULT_SPINNER_SIZE;

  return (
    <Wrapper sxProps={wrapperSxProps}>
      <Button disabled={loading || disabled} sx={{ ...buttonSxProps }} {...rest}>
        {loading ? (
          <CircularProgress size={spinnerSize} className="spinner" {...spinnerProps} />
        ) : (
          <Box>{rest.children}</Box>
        )}
      </Button>
    </Wrapper>
  );
};
